<template>
    <div class="d-flex flex-column" id="patient-profile-details">
        <HHProfileDetails
            :selectedPatientDetails="selectedPatientDetails"
            :patientRiskDetails="patientRiskDetails"
            :patientDetails="patientDetails"
        />
        <div class="task-filters">
            <select class="form-select w-35 me-2" name="benefit-periods" v-model="selectedDiscipline">
                <option :value="null">All Disciplines</option>
                <option v-for="[key, item] in disciplines" :value="item.value" :key="key">
                    {{ item.name }}
                </option>
            </select>
            <select
                class="form-select w-35 me-2"
                name="benefit-periods"
                v-model="selectedEpisode"
                @change="handleSelectDateRange"
            >
                <option value="All">All</option>
                <option value="DateRange">Date Range</option>
                <option v-for="(item, index) in episodeList" :value="item.title" :key="`${index}-${item.title}`">
                    {{ item.title }}
                </option>
            </select>
            <div v-if="showDateRange">
                <DateRangePicker :options="{ startDate: dateFrom, endDate: dateTo }">
                    <input
                        type="text"
                        class="form-control"
                        name="daterange"
                        placeholder="MM/DD/YYYY"
                        :value="newDateRange"
                        @change="(event) => setnewTaskDateRange(event.target.value)"
                /></DateRangePicker>
            </div>
            <span v-if="showRangeText" class="ms-2">{{ range }}</span>
        </div>
        <div class="task-list">
            <main class="bg-white rounded mt-2 h-100">
                <div class="h-100 d-flex flex-column mb-3 mt-2">
                    <table class="table table-responsive-md border border-gray">
                        <thead>
                            <tr class="bg-table-header table-header">
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        class="justify-content-start"
                                        sort-string="TaskName"
                                        >Task</SortableTh
                                    >
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        class="justify-content-start"
                                        sort-string="Status"
                                        >Status</SortableTh
                                    >
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        class="justify-content-start"
                                        sort-string="StartDate"
                                        >Schedule Start</SortableTh
                                    >
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        class="justify-content-start"
                                        sort-string="EndDate"
                                        >Schedule End</SortableTh
                                    >
                                </th>
                                <th>
                                    <SortableTh
                                        :sort-by="sortBy"
                                        v-on:sortByUpdated="sortByUpdated"
                                        :sort-order="sortOrder"
                                        v-on:sortOrderUpdated="sortOrderUpdated"
                                        class="justify-content-start"
                                        sort-string="UserFirstName"
                                        >Assigned To</SortableTh
                                    >
                                </th>
                                <th>Comments</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                                <td :colspan="columns">
                                    <h3>No Tasks Found.</h3>
                                </td>
                            </tr>
                            <tr class="table-error" v-if="!isLoading && isError">
                                <td :colspan="columns">
                                    <ErrorMessageHandler
                                        title="Unassigned visit list"
                                        v-on:try-again="getPatientTasks()"
                                    />
                                </td>
                            </tr>
                            <template v-if="isLoading">
                                <tr v-for="i of loadingCount" class="table-loading" :key="i">
                                    <td v-for="i of columns" :key="i">
                                        <span class="shimmer-loading"></span>
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                        <template v-if="!isLoading && !isError && hasData">
                            <tbody v-for="task of allTasks" :key="task.Id">
                                <HHTaskRow
                                    :task="task"
                                    :columns="columns"
                                    :getPatientTasks="getPatientTasks"
                                    :application="application"
                                />
                            </tbody>
                        </template>
                    </table>
                </div>
            </main>
        </div>
    </div>
</template>

<script src="./HHPatientDetails.ts"></script>
